import styles from "./result-group.module.scss";
import classNames from "classnames";
import useStore, { ResultGroup as ResultSetGroup } from "../../store";
import { useParams } from "react-router-dom";

const ResultGroup = ({ name, isActive }: ResultSetGroup) => {
  const { eventId } = useParams();
  const { setResultSetActive, resultSets } = useStore();

  return (
    <div
      className={classNames(styles.resultGroup, {
        [styles.activeResultGroup]: isActive,
      })}
      onClick={() => {
        const resultsForThisGroup = resultSets.filter(
          (set) => set.groupName === name
        );
        const firstResultSetId = resultsForThisGroup[0]
          ? resultsForThisGroup[0].id
          : "";
        setResultSetActive(eventId || "", firstResultSetId);
      }}
    >
      {name}
    </div>
  );
};

export default ResultGroup;
